import React from 'react';
import PropTypes from 'prop-types';
import infoIcon from '../../../assets/svgs/infoIcon.svg';
import styles from './index.module.css';

export const DRIVER_ON_SITE_DRIVER_PORTAL_TEXT =
  'Note : Driver must wait on-site between Leg A & Leg B';

export const DRIVER_ON_SITE_RIDE_DETAILS_TEXT =
  'Driver required to remain on-site between Leg A & B';

export const DriverOnSiteNotice = ({ className, variant = 'rideDetails' }) => {
  const isDriverPortal = variant === 'driverPortal';
  const message = isDriverPortal
    ? DRIVER_ON_SITE_DRIVER_PORTAL_TEXT
    : DRIVER_ON_SITE_RIDE_DETAILS_TEXT;

  return (
    <div
      className={[
        styles.notice,
        isDriverPortal ? styles.noticeDriverPortal : styles.noticeRideDetails,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="status"
    >
      <img src={infoIcon} alt="" className={styles.noticeIcon} aria-hidden />
      <span className={styles.noticeText}>{message}</span>
    </div>
  );
};

DriverOnSiteNotice.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['rideDetails', 'driverPortal']),
};
